import React from "react"

import { useStyles } from "@/components/QuorumFormProvider/Content/Content.styles"

export const Content = ({ children }) => {
    const { classes } = useStyles()

    // Wrap the content in a div to set up for the FormStep background striping
    return <div className={classes.content}>{children}</div>
}
